import { VendorSalesDetailPage } from "@/features/vendor-app/pages/VendorSalesDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/vendor/sales/$salesConsignmentInvoiceID",
)({
	component: VendorSalesDetailPage,
});
